export default __webpack_public_path__ + "static/media/windpark--bockhorn_DJI_0277.beebb165.jpg";